import SvgIcon from "@mui/material/SvgIcon"

export const DoubleArrowVericalIcon = () => {
    return (
        <SvgIcon>
            <path d="M7 14l5 5l5 -5z M17 10 l-10 0l5 -5z" />
        </SvgIcon>
    )
}
export default DoubleArrowVericalIcon